import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {ValidatorService} from "../../../../services/validator.service";
import {CountriesListService} from "../../../../services/countries-list.service";
// TODO(RZ-2562): Replace legacy VO types (OrganizationVO) with SDK equivalents (Organization)
import {OrganizationVO} from '../../../../generate/OrganizationVO';
import {UtilService} from '../../../../util/util.service';
import {requiredFieldValidator} from '../../../../validators/required-field-validator.directive';
import {ErrorVO} from '../../../../generate/ErrorVO';
import {
  whitelistCharacterValidator
} from '../../../../validators/valid-character-validator.directive';

@Component({
    selector: 'sponsoring-org-edit',
    templateUrl: './sponsoring-org-edit.component.html',
    styleUrls: ['./sponsoring-org-edit.component.scss'],
    standalone: false
})
export class SponsoringOrgEditComponent implements OnInit {

  @Input()
  newDelegation: boolean;

  @Input()
  organizationVO: OrganizationVO;

  @Output()
  sponsoringOrgVOOutput = new EventEmitter<OrganizationVO>();

  @Output()
  cancelOutPut = new EventEmitter<boolean>();

  editSOForm: FormGroup;

  countries: any[] = [];

  showOtherCountryElement: boolean;

  errors: ErrorVO;

  get organizationName(): FormControl { return this.editSOForm.get('organizationName') as FormControl; }
  get streetAddress(): FormControl { return this.editSOForm.get('streetAddress') as FormControl; }
  get city(): FormControl { return this.editSOForm.get('city') as FormControl; }
  get state(): FormControl { return this.editSOForm.get('state') as FormControl; }
  get otherCountry(): FormControl { return this.editSOForm.get('otherCountry') as FormControl; }
  get postalCode(): FormControl { return this.editSOForm.get('postalCode') as FormControl; }

  constructor(private formBuilder: FormBuilder, private validator: ValidatorService, private util: UtilService, private countriesListService: CountriesListService) {
  }

  ngOnInit() {
    this.countries = this.countriesListService.countriesList;
    this.createForm();
  }

  cancel() {
    this.cancelOutPut.emit(true);
  }


  onSubmit() {
    const formValue = this.editSOForm.value;

    let modifiedSO = {
      organizationName: this.util.returnNullIfEmpty(formValue.organizationName),
      address: this.countriesListService.buildAddressFromForm(formValue)
    };
    
    // Remove null properties to comply with OpenAPI schema (Optional & Not Nullable)
    modifiedSO = this.util.removeNullProperties(modifiedSO) as any;

    this.validator.validateSOContact(modifiedSO).subscribe(data => {
      if (data == null) {
        this.organizationVO.address = modifiedSO.address;
        this.organizationVO.organizationName = modifiedSO.organizationName;
        this.sponsoringOrgVOOutput.emit(this.organizationVO);
      } else {
        this.errors = data;
      }
    });

  }

  displayValidationError(controlName: string): boolean {
    return this.editSOForm.contains(controlName)
      && !this.editSOForm.get(controlName).valid
      && this.editSOForm.get(controlName).touched
  }

  displayServerValidationError(field: string): string[] {
    let error: ErrorVO = this.util.getFieldError(field, this.errors);
    if (error != null) {
      return error.errorMessages;
    }
  }

  displayAddressValidationError(field: string): string[] {
    let error: ErrorVO = this.util.getFieldError("address", this.errors);
    if (error != null) {
      let fieldError: ErrorVO = this.util.getFieldError(field, error);
      if (fieldError != null) {
        return fieldError.errorMessages;
      }
    }
  }

  private createForm() {
    if (this.organizationVO == null) {
      this.organizationVO = {};
    }

    if (this.organizationVO.address == null) {
      this.organizationVO.address = {};
    }

    this.editSOForm = this.formBuilder.group({
      organizationName: [this.organizationVO.organizationName, [requiredFieldValidator, whitelistCharacterValidator]],
      streetAddress: [this.organizationVO.address.streetAddress, [requiredFieldValidator, whitelistCharacterValidator]],
      city: [this.organizationVO.address.city, [whitelistCharacterValidator]],
      state: [this.organizationVO.address.state, [whitelistCharacterValidator]],
      countryName: [this.countriesListService.getCountry(false, this.organizationVO.address), [requiredFieldValidator]],
      otherCountry: [this.countriesListService.getCountry(true, this.organizationVO.address), [whitelistCharacterValidator]],
      postalCode: [this.organizationVO.address.postalCode, [whitelistCharacterValidator]]
    });

    this.showOtherElement();
  }

  showOtherElement() {
    this.showOtherCountryElement = this.editSOForm.value.countryName === "other";
  }

}
